import { CHESS_SVG } from '../../../chess-svgs.js';
import { coordForGame } from '../../core/game-adapter.js';

function addCoords(square, idx, flipped) {
  const file = idx % 8;
  const rank = 8 - Math.floor(idx / 8);
  const bottomRank = flipped ? 8 : 1;
  const leftFile = flipped ? 7 : 0;

  if (rank === bottomRank) {
    const fileLabel = document.createElement('span');
    fileLabel.className = 'coord file';
    fileLabel.textContent = 'abcdefgh'[file];
    square.appendChild(fileLabel);
  }

  if (file === leftFile) {
    const rankLabel = document.createElement('span');
    rankLabel.className = 'coord rank';
    rankLabel.textContent = String(rank);
    square.appendChild(rankLabel);
  }
}

export function renderChessBoard(boardEl, board, {
  flipped = false,
  lastMove = null,
  selectedIdx = null,
  legalMoves = [],
  inCheck = false,
  sideToMove = 'w',
  onClick = () => {}
} = {}) {
  boardEl.innerHTML = '';
  const order = [...Array(64).keys()];
  if (flipped) order.reverse();

  const checkedKing = inCheck
    ? board.indexOf(sideToMove === 'w' ? 'K' : 'k')
    : -1;

  for (const idx of order) {
    const row = Math.floor(idx / 8);
    const col = idx % 8;
    const square = document.createElement('button');
    square.type = 'button';
    square.className = 'square';
    square.classList.add((row + col) % 2 ? 'dark' : 'light');
    square.dataset.idx = String(idx);
    square.setAttribute('role', 'gridcell');
    square.setAttribute('aria-label', coordForGame('chess', idx));

    if (selectedIdx === idx) square.classList.add('selected');
    const legalMove = legalMoves.find(move => move.to === idx);
    if (legalMove) square.classList.add(legalMove.captured || legalMove.enPassant ? 'capture' : 'legal');

    if (lastMove && (lastMove.from === idx || lastMove.to === idx)) {
      square.classList.add('last');
      if (lastMove.to === idx) square.classList.add('last-to');
      if (lastMove.from === idx) square.classList.add('last-from');
    }

    if (lastMove?.captured && lastMove.to === idx) square.classList.add('capture-event');
    if (inCheck && lastMove && (lastMove.from === idx || lastMove.to === idx)) square.classList.add('checking-move');
    if (idx === checkedKing) square.classList.add('in-check');

    const piece = board[idx];
    if (piece) {
      const span = document.createElement('span');
      span.className = 'piece';
      span.innerHTML = CHESS_SVG[piece] || '';
      square.appendChild(span);
    }

    addCoords(square, idx, flipped);
    square.addEventListener('click', () => onClick(idx));
    boardEl.appendChild(square);
  }
}
